import React from 'react';
import Lottie from 'react-lottie';
import animationData from '../../../assets/lottie/empty-box.json';

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};
type Props = {
  width: number;
  height: number;
};
const EmptyBoxAnimation = ({ width, height }: Props) => {
  return <Lottie options={defaultOptions} height={height} width={width} />;
};

export default EmptyBoxAnimation;
